module.exports = __webpack_public_path__ + "static/img/Canoe_VOD-Default.9d0d29f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Canoe_VOD-Default.png
// module id = 1585
// module chunks = 0